import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { StartConnectionResponse } from '@polyai/schemas';

import { startIntegrationConnection } from 'api/resources/integrations';
import useProjectRoute from './useProjectRoute';

/**
 * React Query hook for getting Paragon authentication token
 */
export const useStartIntegrationConnection = (options?: {
  enabled?: boolean;
}) => {
  const { accountId, projectId } = useProjectRoute();

  const queryOptions: UseQueryOptions<StartConnectionResponse> = {
    queryKey: ['integrations', 'start-connection', accountId, projectId],
    queryFn: async (): Promise<StartConnectionResponse> => {
      if (!accountId || !projectId) {
        throw new Error('Account ID and Project ID are required');
      }
      return startIntegrationConnection({ accountId, projectId });
    },
    enabled: (options?.enabled ?? true) && !!accountId && !!projectId,
    staleTime: 5 * 60 * 1000, // Consider data stale after 5 minutes
    cacheTime: 10 * 60 * 1000, // Cache time before garbage collection
  };

  return useQuery(queryOptions);
};
